import { OperacionWRMFields } from '../api'
import { z } from 'src/lib'

export const schemaOperacionWRM = z.object({
    [OperacionWRMFields.CodSectorComercial]: z.number(),
    [OperacionWRMFields.Observaciones]: z.string().optional(),
    [OperacionWRMFields.FechaEmision]: z.date(),
    [OperacionWRMFields.FechaVencimiento]: z.date()
})

export type FormOperacionWRM = z.infer<typeof schemaOperacionWRM>
